// <contact-form> (§7.10): muestra los campos de talla con el motivo «talla», los rellena desde el buscador
// (sessionStorage), valida en español junto a cada campo con un resumen enlazado y etiqueta el envío
// (contact[tags] = talla | contacto). Publica contact_submit y, si es por la talla, size_help.
// El <form> es el {% form 'contact' %} de Shopify: los textos van en el elemento y, sin JS, valida el navegador.
class ContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.s = JSON.parse(this.dataset.strings ?? this.form.dataset.strings);
    this.form.noValidate = true;
    this.reason = this.form.querySelector('[data-reason]');
    this.sizeFields = this.form.querySelector('[data-size-fields]');
    this.summary = this.form.querySelector('.form-summary');
    const fromUrl = new URL(location.href).searchParams.get('motivo');
    if (fromUrl && [...this.reason.options].some((o) => o.value === fromUrl)) this.reason.value = fromUrl;
    this.reason.addEventListener('change', () => this.sync());
    this.prefill();
    this.sync();
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  sync() {
    const size = this.reason.value === 'talla';
    this.sizeFields.hidden = !size;
    this.form.querySelector('[data-tags]').value = size ? 'talla' : 'contacto';
    this.form.querySelector('[data-submit]').textContent = size ? this.s.sendMeasures : this.s.send;
  }

  prefill() {
    try {
      const saved = JSON.parse(sessionStorage.getItem('pawly-medidas') ?? 'null');
      if (!saved) return;
      const set = (name, value) => {
        const field = this.form.elements[name];
        if (field && value && !field.value) field.value = value;
      };
      set('contact[peso]', saved.weight);
      set('contact[pecho]', saved.chest);
      set('contact[cintura]', saved.waist);
      if (saved.sex) this.form.querySelector(`input[name="contact[sexo]"][value="${saved.sex}"]`)?.click();
    } catch {
      // Sin sessionStorage no hay nada que rellenar.
    }
  }

  setError(id, message) {
    const field = this.form.querySelector(`#${id}`);
    const error = this.form.querySelector(`#${id}-error`);
    if (message) {
      error.querySelector('span').textContent = message;
      error.hidden = false;
      field.setAttribute('aria-invalid', 'true');
    } else {
      error.hidden = true;
      field.removeAttribute('aria-invalid');
    }
    return message ? { id, message } : null;
  }

  onSubmit(event) {
    const value = (name) => this.form.elements[name].value.trim();
    const errors = [
      this.setError('contact-name', value('contact[name]') ? '' : this.s.name),
      this.setError('contact-email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value('contact[email]')) ? '' : this.s.email),
      this.setError('contact-message', value('contact[body]') || this.reason.value === 'talla' ? '' : this.s.message),
      this.setError('contact-privacy', this.form.elements['contact[privacidad]'].checked ? '' : this.s.privacy),
    ].filter(Boolean);
    if (errors.length) {
      event.preventDefault();
      const list = document.createElement('ul');
      for (const error of errors) {
        const link = document.createElement('a');
        link.href = `#${error.id}`;
        link.textContent = error.message;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.form.querySelector(`#${error.id}`).focus();
        });
        const li = document.createElement('li');
        li.append(link);
        list.append(li);
      }
      const title = document.createElement('p');
      title.textContent = this.s.errorsTitle;
      this.summary.replaceChildren(title, list);
      this.summary.hidden = false;
      this.summary.focus();
      return;
    }
    window.Shopify?.analytics?.publish?.('pawly:contact_submit', { reason: this.reason.value });
    if (this.reason.value === 'talla') window.Shopify?.analytics?.publish?.('pawly:size_help', { channel: 'form', location: 'contact' });
  }
}

customElements.define('contact-form', ContactForm);
